import React, { FC, ReactNode, useEffect, useState } from 'react';

import { Button, EasyModal } from '@ui';

import { useIsOverflow } from '@app/hooks/use-overflow';

import useTranslation from '@app/hooks/use-translation';

import { ChevronDownIcon } from '@app/components/ui/icons/icons-list';

import AppealFilterModal from './appeal-filter-modal';
import { AppealFilterType, FilterOptionsListAndRules } from './types';

type AppealFilterProps = {
  data?: AppealFilterType;
  titleMarkup?: ReactNode;
  keysForFiltering: FilterOptionsListAndRules[];
  onChangeHandler(data: AppealFilterType): void;
  customFilterLabel?: string;
  disabledChangeButton?: boolean;
  disableSaveButton?: boolean;
  additionalFilterKeys?: {
    keyName: string;
    options: FilterOptionsListAndRules[];
    buttonLabel: string;
    fieldName: 'id' | 'field';
  }[];
};
const AppealFilter: FC<AppealFilterProps> = (props) => {
  const { t } = useTranslation('components.filter');
  const {
    data = {
      filter: [],
    },
    customFilterLabel: customFilterLabel,
    titleMarkup,
    keysForFiltering,
    additionalFilterKeys,
    onChangeHandler,
    disableSaveButton,
    disabledChangeButton,
  } = props;

  // const valueClassName = 'bg-defaultBg px-[8px] pt-[2px] pb-[3px] rounded-[4px]';
  // const [calendarBindValue, changeCalendarBindValue] = useState(metaDateTimeCalendar[0].id);
  const [filterData, changeFilterData] = useState(data);
  const [filterOpenState, changeFilterOpenState] = useState(false);
  const [filterFullHeight, changeFilterFullHeightState] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const [filterViewRef, setFilterViewRef] = useState<HTMLDivElement | null>(null);

  function onChangeFullHeightFilter() {
    changeFilterFullHeightState((prev) => !prev);
  }
  function changeFilterModalState() {
    changeFilterOpenState(true);
  }

  function getNameByValueKey(key, options: FilterOptionsListAndRules[]) {
    return options.find((item) => item.index === key)?.title || 'N/A';
  }

  function getNameByValue(key, value, options: FilterOptionsListAndRules[]) {
    return (
      options
        ?.find((item) => item.index === key)
        ?.select?.options?.find((item) => item.value === value)?.title || value
    );
  }

  function onChangeFilter(data: AppealFilterType) {
    onChangeHandler(data);
    changeFilterData(data);
  }

  // function onFillFromTemplateHandler(data: AppealFilterType & Range) {
  //   changeFilterData(data);
  //   // onChangeHandler(data);
  // }

  useIsOverflow(filterViewRef as HTMLElement, (isOverflow) => setOverflow(isOverflow));
  useEffect(() => {
    if (!data) return;
    changeFilterData(data);
  }, [data]);

  return (
    <>
      <div className="pt-[20px] pb-[20px] pr-[25px] pl-[22px] bg-white border-l-[2px] border-l-speech_analitics rounded-xl">
        {titleMarkup && <div className="text-[18px] leading-[21px]">{titleMarkup}</div>}
        {/* <div className={'flex w-full items-center gap-[6px] py-[15px] pb-[20px]'}> */}
        {/* <div className={'text-[15px] leading-[18px]'}>
            {metaDateTimeForRangeShow[filterData.range.type]}
          </div> */}
        {/* <div className={'text-[15px] leading-[18px]'}>
            {renderRangeValues[filterData.range.type]}
          </div> */}
        {/* </div> */}

        <div className={'flex w-full'}>
          <div
            onDoubleClick={disabledChangeButton ? undefined : changeFilterModalState}
            className={
              'relative pl-[19.34px] py-[4.5px] w-full bg-white border border-b_dark rounded-defaultR truncate mr-6'
            }
            style={{ height: filterFullHeight ? '100%' : '34px' }}
            ref={(ref) => setFilterViewRef(ref)}
          >
            <div
              style={{ width: 'calc(100% - 50px)' }}
              className={`flex flex-wrap gap-y-[10px] w-full px-2`}
            >
              {filterData?.filter.map((filter, index) => (
                <div key={index} className={'relative flex items-center '}>
                  {filter.field && (
                    <div className="min-w-max pr-[6px] text-[15px] leading-[18px] ">
                      {getNameByValueKey(filter.field, keysForFiltering)}
                    </div>
                  )}
                  {filter.condition && (
                    <div className="flex justify-center items-center w-[22px] h-[22px]  text-2color text-[15px] leading-[16px] mr-[6px] pb-[2px] border border-b_dark rounded-full">
                      {/* conditionsWithoutValue.includes(filter.condition)
                        ? conditionsWithoutValueDisplay[filter.condition] || 'e'
                        :  */}
                      {filter.condition}
                    </div>
                  )}
                  <div className={'pr-[16px] flex items-center gap-[5px]'}>
                    {Array.isArray(filter.value)
                      ? filter.value.map(
                          (value, indexValue) =>
                            value && (
                              <div className={'flex items-center'} key={indexValue}>
                                {indexValue <= value.length - 1 && indexValue === 0 && (
                                  <div className={'pr-1.5'}>(</div>
                                )}
                                <div
                                  className={
                                    'bg-defaultBg w-fit text-[15px] leading-[18px] text-2color px-[8px] pt-[2px] pb-[3px] rounded-[4px]'
                                  }
                                >
                                  {getNameByValue(filter.field, value, keysForFiltering)}
                                </div>
                                {indexValue < filterData.filter[index]?.value.length - 1 && (
                                  <div className="px-[4px] text-[15px] leading-[18px] ml-[5px] border rounded-full text-2color">
                                    {t('or')}
                                  </div>
                                )}
                                {indexValue === filterData.filter[index]?.value.length - 1 && (
                                  <div className={'pl-1.5'}>)</div>
                                )}
                              </div>
                            ),
                        )
                      : filter.value && (
                          <div
                            className={
                              'bg-defaultBg px-[8px] pt-[2px] pb-[3px] rounded-[4px] w-fit text-[15px] leading-[18px] text-2color'
                            }
                          >
                            {getNameByValue(filter.field, filter.value, keysForFiltering)}
                          </div>
                        )}
                  </div>
                </div>
              ))}
              {additionalFilterKeys?.map(({ keyName, options, fieldName }) =>
                filterData?.[keyName]?.map((filter, index) => (
                  <div key={index} className={'relative flex items-center '}>
                    {filter?.[fieldName] && (
                      <div className="min-w-max pr-[6px] text-[15px] leading-[18px] ">
                        {getNameByValueKey(filter?.[fieldName], options)}
                      </div>
                    )}
                    {filter.condition && (
                      <div className="flex justify-center items-center w-[22px] h-[22px]  text-2color text-[15px] leading-[16px] mr-[6px] pb-[2px] border border-b_dark rounded-full">
                        {/* conditionsWithoutValue.includes(filter.condition)
                        ? conditionsWithoutValueDisplay[filter.condition] || 'e'
                        :  */}
                        {filter.condition}
                      </div>
                    )}
                    <div className={'pr-[16px] flex items-center gap-[5px]'}>
                      {Array.isArray(filter.value)
                        ? filter.value.map(
                            (value, indexValue) =>
                              value && (
                                <div className={'flex items-center'} key={indexValue}>
                                  {indexValue <= value.length - 1 && indexValue === 0 && (
                                    <div className={'pr-1.5'}>(</div>
                                  )}
                                  <div
                                    className={
                                      'bg-defaultBg w-fit text-[15px] leading-[18px] text-2color px-[8px] pt-[2px] pb-[3px] rounded-[4px]'
                                    }
                                  >
                                    {getNameByValue(filter?.[fieldName], value, options)}
                                  </div>
                                  {indexValue < filterData.filter[index]?.value.length - 1 && (
                                    <div className="px-[4px] text-[15px] leading-[18px] ml-[5px] border rounded-full text-2color">
                                      {t('or')}
                                    </div>
                                  )}
                                  {indexValue === filterData.filter[index]?.value.length - 1 && (
                                    <div className={'pl-1.5'}>)</div>
                                  )}
                                </div>
                              ),
                          )
                        : filter.value && (
                            <div
                              className={
                                'bg-defaultBg px-[8px] pt-[2px] pb-[3px] rounded-[4px] w-fit text-[15px] leading-[18px] text-2color'
                              }
                            >
                              {getNameByValue(filter?.[fieldName], filter.value, options)}
                            </div>
                          )}
                    </div>
                  </div>
                )),
              )}
            </div>
            {(overflow || filterFullHeight) && (
              <div
                onClick={onChangeFullHeightFilter}
                className={`absolute right-[8px] bottom-[6px] cursor-pointer p-[5px] bg-defaultBg rounded-[4px] ${
                  filterFullHeight && 'rotate-180'
                }`}
              >
                <ChevronDownIcon size={12} />
              </div>
            )}
          </div>
          <Button
            label={t('change')}
            fill="outlined"
            icon="Edit2Icon"
            className="self-start"
            disabled={disabledChangeButton}
            onClick={() => changeFilterModalState()}
          />
        </div>
      </div>

      <EasyModal
        withoutFooter
        label={<div className={'pb-[30px]'}>{customFilterLabel || t('edit_filter')}</div>}
        withoutContentPadding
        show={filterOpenState}
        onClose={() => {
          changeFilterOpenState(false);
        }}
        variant={'largeW1127'}
      >
        {filterOpenState && (
          <AppealFilterModal
            onChange={(data) => onChangeFilter(data)}
            changeFilterOpenState={changeFilterOpenState}
            keysForFiltering={keysForFiltering}
            additionalFilterKeys={additionalFilterKeys}
            disable={disableSaveButton}
            data={onFilterInputAppeal(filterData, additionalFilterKeys)}
          />
        )}
      </EasyModal>
    </>
  );
};
export default AppealFilter;

const onFilterInputAppeal = (
  data: AppealFilterType,
  additionalFilterKeys:
    | {
        keyName: string;
        options: FilterOptionsListAndRules[];
        buttonLabel: string;
        fieldName: 'id' | 'field';
      }[]
    | undefined,
) => {
  const allDataFormatting = Object.entries(data).reduce<Partial<AppealFilterType>>((acc, cur) => {
    const key = cur[0];
    const value = cur[1];
    const valueKey = additionalFilterKeys?.find((filter) => filter.keyName === key)?.fieldName;
    const empty = {
      filter: [
        {
          [valueKey || 'field']: '',
          condition: '',
          value: [''],
        },
      ],
    } as AppealFilterType;
    acc[key] = [...(value || []), ...empty.filter].map((filter) => {
      return {
        ...filter,
        value: Array.isArray(filter.value) ? filter.value : [filter.value],
      };
    });

    return acc;
  }, {});
  return {
    ...data,
    ...allDataFormatting,
  };
};
